import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerServiceWorker } from './hooks/usePushNotifications';
import { fetchAndApplyBranding } from './config/branding';
import { patchDatePrototypeWithTimezone, setUserTimezone } from './utils/timezone';
import { isNativePlatform } from './utils/platform';

// Patch Date methods to use configured timezone globally
patchDatePrototypeWithTimezone();

// Load timezone from persisted auth store (localStorage) on startup
try {
  const stored = localStorage.getItem('neimus360-auth');
  if (stored) {
    const parsed = JSON.parse(stored);
    const tz = parsed?.state?.user?.timezone;
    if (tz) setUserTimezone(tz);
  }
} catch {
  // No stored auth or invalid JSON — will use browser timezone
}

// Fetch and apply system branding from API on startup
fetchAndApplyBranding();

// Register immediately after load, or wait for load when the document is still starting.
if ('serviceWorker' in navigator && import.meta.env.PROD && !isNativePlatform()) {
  const registerPushWorker = () => { void registerServiceWorker(); };
  if (document.readyState === 'complete') registerPushWorker();
  else window.addEventListener('load', registerPushWorker, { once: true });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
